"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startAppTimer = exports.TASK_MAX_TIME = void 0;
exports.getActiveTaskElapsedMs = getActiveTaskElapsedMs;
exports.finalizeCurrentPauseSegment = finalizeCurrentPauseSegment;
exports.checkEndTaskEarly = checkEndTaskEarly;
exports.checkMaxTimeExceeded = checkMaxTimeExceeded;
const taskStore_1 = require("../../../taskStore");
const trials_1 = require("../trials");
const PageStateHandler_1 = require("./PageStateHandler");
// In minutes
exports.TASK_MAX_TIME = {
    trog: {
        1: 5,
    },
    'roar-inference': {
        1: 10,
    },
};
// This feature allows the task configurator to set a time limit for the app,
// configured via url and store variable maxTime.
// Preload time is not included in the time limit
// buffer in milliseconds after presentation of stimulus to allow some time to answer
const RESPONSE_BUFFER = 2000;
function getActiveTaskElapsedMs() {
    var _a;
    const startTime = (0, taskStore_1.taskStore)().startTime;
    if (typeof startTime !== 'number')
        return 0;
    const accumulatedPauseMs = (_a = (0, taskStore_1.taskStore)().taskTimerPausedMs) !== null && _a !== void 0 ? _a : 0;
    const pauseBeganAt = (0, taskStore_1.taskStore)().taskTimerPauseBeganAt;
    const currentPauseMs = typeof pauseBeganAt === 'number' ? Date.now() - pauseBeganAt : 0;
    return Date.now() - startTime - accumulatedPauseMs - currentPauseMs;
}
function finalizeCurrentPauseSegment() {
    var _a;
    const pauseBeganAt = (0, taskStore_1.taskStore)().taskTimerPauseBeganAt;
    if (typeof pauseBeganAt !== 'number')
        return;
    (0, taskStore_1.taskStore)('taskTimerPausedMs', ((_a = (0, taskStore_1.taskStore)().taskTimerPausedMs) !== null && _a !== void 0 ? _a : 0) + (Date.now() - pauseBeganAt));
    (0, taskStore_1.taskStore)('taskTimerPauseBeganAt', null);
}
const startAppTimer = (maxTimeInMinutes) => {
    // Minimum time is 1 minute
    const maxTimeInMilliseconds = Math.max(maxTimeInMinutes, 1) * 60000;
    (0, taskStore_1.taskStore)('startTime', Date.now());
    (0, taskStore_1.taskStore)('taskTimerPausedMs', 0);
    (0, taskStore_1.taskStore)('taskTimerPauseBeganAt', null);
    const timerId = setTimeout(() => {
        (0, taskStore_1.taskStore)('maxTimeReached', true);
        clearTimeout(timerId);
    }, maxTimeInMilliseconds);
    (0, taskStore_1.taskStore)('taskTimer', timerId);
};
exports.startAppTimer = startAppTimer;
// function for ending the task if the next trial
async function checkEndTaskEarly(timeRemaining, stimAudio) {
    const pageStateHandler = new PageStateHandler_1.PageStateHandler(stimAudio, false);
    const minTrialDuration = (await pageStateHandler.getStimulusDurationMs()) + RESPONSE_BUFFER;
    if (timeRemaining < minTrialDuration) {
        clearTimeout((0, taskStore_1.taskStore)().taskTimer);
        (0, trials_1.finishExperiment)();
    }
}
function checkMaxTimeExceeded(stimAudio) {
    var _a, _b;
    const { task, scoringVersion, maxTime: storeMaxTime } = (0, taskStore_1.taskStore)();
    // storeMaxTime defaults to 100 if nothing is passed
    const maxTime = (_b = (_a = exports.TASK_MAX_TIME[task]) === null || _a === void 0 ? void 0 : _a[scoringVersion]) !== null && _b !== void 0 ? _b : storeMaxTime;
    if (maxTime == null) {
        return; // No max time configured, skip check
    }
    const maxTimeInMilliseconds = maxTime * 60000;
    const timeRemaining = maxTimeInMilliseconds - getActiveTaskElapsedMs();
    checkEndTaskEarly(timeRemaining, stimAudio);
}
